import {
  actions as DRAFT_ACTIONS,
  DraftActionType,
  PossibleActions,
  reduceAction,
} from '../../../../../DraftActions';

const withActionLabel = (
  draftAction: DraftActionType,
  label: string,
): DraftActionType => ({
  ...draftAction,
  action: { ...draftAction.action, label },
});

const CELL_EDITOR_ACTIONS: DraftActionType[] = [
  DRAFT_ACTIONS[PossibleActions.BOLD],
  DRAFT_ACTIONS[PossibleActions.ITALIC],
  DRAFT_ACTIONS[PossibleActions.STRIKETHROUGH],
  DRAFT_ACTIONS[PossibleActions.LIST],
  DRAFT_ACTIONS[PossibleActions.ORDERED_LIST],
  withActionLabel(DRAFT_ACTIONS[PossibleActions.LINK], 'Lien'),
];

export const CELL_EDITOR_CONFIG = reduceAction(CELL_EDITOR_ACTIONS);
